import request from "../utils/request";

export const GOOGLE_BUSINESS_API = {
    listLocations: (channelId, page = 1, limit = 25) => {
        return request.get(`/google-business/channels/${channelId}/locations`, { params: { page, limit } });
    },

    syncLocations: (channelId) => {
        return request.post(`/google-business/channels/${channelId}/locations/sync`);
    },

    listReviews: (data) => {
        return request.post(`/google-business/reviews`, data);
    },

    fetchReviews: (channelId, locationId, pageToken) => {
        const params = pageToken ? { pageToken } : {};
        return request.get(`/google-business/channels/${channelId}/locations/${locationId}/fetch-reviews`, { params });
    },

    replyReview: (reviewId, data) => {
        return request.post(`/google-business/reviews/${reviewId}/reply`, data);
    },

    updateStatus: (reviewId, status, assigneeId) => {
        return request.put(`/google-business/reviews/${reviewId}/status`, { status, assigneeId });
    },
};
